import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';

import SocialLogin from './SocialLogin';
import TextInput from './../Inputs/TextInput';
import Button from './../Inputs/Button';
import { FORGOT_PASSWORD_FORM } from '../../../constants/forms';
import { required, minLength } from '../../../utils/validators';
import i18n from '../../../i18n/i18n.js';

const minLength8 = minLength(8, 'password');

const LoginForm = props => {
    const lng = props.lng;

    return (
        <Fragment>
            <SocialLogin social={props.social} />
            <section id="ipx-maincontent">
                <form onSubmit={props.handleSubmit} className="formelements">
                    <Field
                        component={TextInput}
                        type="text"
                        name="email"
                        label={i18n.t('placeholder_email_address', { lng })}
                        className="labelholder"
                        validate={[required]}
                        lng={lng}
                        handleFocus={props.handleFocus}
                        active={props.name === 'email' ? props.active : false}
                        primaryColor={props.branding.paywall_primary_color}
                    />

                    <div className="inplayer-passwordrecov">
                        <Field
                            type="password"
                            name="password"
                            label={i18n.t('placeholder_password', { lng })}
                            component={TextInput}
                            className="labelholder pswresetfield"
                            validate={[required]}
                            lng={lng}
                            handleFocus={props.handleFocus}
                            active={
                                props.name === 'password' ? props.active : false
                            }
                            primaryColor={props.branding.paywall_primary_color}
                        />
                    </div>
                    <div className="passwordreset">
                        <label>
                            <span
                                onClick={e => {
                                    e.preventDefault();
                                    props.changeForm(FORGOT_PASSWORD_FORM);
                                }}
                            >
                                {i18n.t('tooltip_forgot_password', { lng })}
                            </span>
                        </label>
                    </div>

                    <div className="inplayer-buttonholder">
                        <div className="buttonholder">
                            <Button
                                text={i18n.t('log_in', { lng })}
                                backgroundColor={
                                    props.branding.paywall_buttons_bg_color
                                }
                                touched={
                                    props.params && props.params.anyTouched
                                }
                                errors={
                                    props.params && props.params.syncErrors
                                        ? true
                                        : false
                                }
                                isLoading={props.isLoading}
                            />
                        </div>
                    </div>
                </form>
            </section>
        </Fragment>
    );
};

export default reduxForm({
    form: 'loginForm',
    initialValues: {
        props: [{}],
    },
})(LoginForm);



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Login.js